/** @jsxImportSource @emotion/react */
"use client";
import type { TheWordGame } from "@packages/sdk";
import type { MouseEventHandler } from "react";
import { useCallback } from "react";

/** Avoid circular dependency */
import { useShareTheWord } from "../../../../../../games/src";
import { IconButton } from "../../_core/IconButton/IconButton.emotion";
import { ShareIcon } from "../../icons/Icon/GeneralIcons";

export const TheWordShareIconButton = ({ game }: { game: TheWordGame }) => {
  const share = useShareTheWord();

  const onClick = useCallback<MouseEventHandler<HTMLButtonElement>>(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      share(game);
    },
    [share, game],
  );

  return (
    <IconButton
      icon={<ShareIcon />}
      onClick={onClick}
      size="s"
      variant="transparentWhite"
    />
  );
};
